import loadable from '@loadable/component';
export const manifest = {
  SidePanel: {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SidePanelDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SidePanelDesktop" */
          './desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./desktop");
            }

            return eval('require.resolve')("./desktop");
          }

        }, {
          resolveComponent: m => m.SidePanelDesktop
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SidePanelMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SidePanelMobile" */
          './mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./mobile");
            }

            return eval('require.resolve')("./mobile");
          }

        }, {
          resolveComponent: m => m.SidePanelMobile
        })
      }
    }
  },
  'SidePanel.Header': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SidePanel.HeaderDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SidePanel.HeaderDesktop" */
          './header-desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./header-desktop");
            }

            return eval('require.resolve')("./header-desktop");
          }

        }, {
          resolveComponent: m => m.HeaderDesktop
        }),
        defaultProps: {
          path: './src/components/header/models/models.manifest.ts',
          name: 'DefaultPropsDesktop'
        }
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SidePanel.HeaderMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SidePanel.HeaderMobile" */
          './header-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./header-mobile");
            }

            return eval('require.resolve')("./header-mobile");
          }

        }, {
          resolveComponent: m => m.HeaderMobile
        }),
        defaultProps: {
          path: './src/components/header/models/models.manifest.ts',
          name: 'DefaultPropsMobile'
        }
      }
    }
  },
  'SidePanel.Content': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SidePanel.ContentDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SidePanel.ContentDesktop" */
          './content-desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./content-desktop");
            }

            return eval('require.resolve')("./content-desktop");
          }

        }, {
          resolveComponent: m => m.ContentDesktop
        }),
        defaultProps: {
          path: './src/components/content/models/models.manifest.ts',
          name: 'DefaultPropsDesktop'
        }
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SidePanel.ContentMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SidePanel.ContentMobile" */
          './content-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./content-mobile");
            }

            return eval('require.resolve')("./content-mobile");
          }

        }, {
          resolveComponent: m => m.ContentMobile
        }),
        defaultProps: {
          path: './src/components/content/models/models.manifest.ts',
          name: 'DefaultPropsMobile'
        }
      }
    }
  },
  'SidePanel.Footer': {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SidePanel.FooterDesktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SidePanel.FooterDesktop" */
          './footer-desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./footer-desktop");
            }

            return eval('require.resolve')("./footer-desktop");
          }

        }, {
          resolveComponent: m => m.FooterDesktop
        }),
        defaultProps: {
          path: './src/components/footer/models/models.manifest.ts',
          name: 'DefaultPropsDesktop'
        }
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SidePanel.FooterMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SidePanel.FooterMobile" */
          './footer-mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./footer-mobile");
            }

            return eval('require.resolve')("./footer-mobile");
          }

        }, {
          resolveComponent: m => m.FooterMobile
        }),
        defaultProps: {
          path: './src/components/footer/models/models.manifest.ts',
          name: 'DefaultPropsMobile'
        }
      }
    }
  }
};